import {css} from '@emotion/css';
import {useMemo} from 'react';

// eslint-disable-next-line no-restricted-imports
import {useTheme} from '@veneer/theme';

const useStyle = (open: boolean) => {
    const theme = useTheme();
    return useMemo(
        () => ({
            self: css({
                display: 'flex',
                alignItems: 'center',
            }),
            toggle: css({
                cursor: 'pointer',
                background: theme.palette.neutral.background,
                borderRadius: '50%',
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
                width: 36,
                height: 36,

                border: `1px solid ${open ? theme.palette.foreground.default : 'transparent'}`,

                '&:focus-visible': {
                    outlineColor: `${theme.palette.primary.default} !important`,
                    outlineOffset: 2,
                    outlineWidth: 2,
                    outlineStyle: 'solid',
                },
            }),
        }),
        [open, theme.palette.foreground.default, theme.palette.neutral.background, theme.palette.primary.default]
    );
};

export default useStyle;
